import { Loading } from 'ui-common'

export default function ReferralsLoading() {
	return (
		<div className='max-w-[80rem] mx-auto px-[2.4rem] py-[2rem]'>
			<Loading width='28rem' height='3.2rem' className='mb-[1rem]' />
			<Loading width='40rem' height='2rem' className='mb-[3.2rem]' />
			<div className='grid grid-cols-1 sm:grid-cols-2 gap-[1.6rem] mb-[3.2rem]'>
				<Loading height='10rem' />
				<Loading height='10rem' />
			</div>
			<Loading height='14rem' className='mb-[2.4rem]' />
			<Loading height='14rem' className='mb-[2.4rem]' />
			<Loading height='12rem' />
		</div>
	)
}
